export default {
      id: "ic-plan-transports-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-plan-transports-usage",
      toString: function () {
        return this.url;
      }
    }